import { create } from 'zustand';

interface DomState {
  scrollTop: number;
  mobileSidebarOpen: boolean;
  setScrollTop: (scrollTop: number) => void;
  setMobileSidebarOpen: (open: boolean) => void;
}

export const useDomStore = create<DomState>()((set) => ({
  scrollTop: 0,
  mobileSidebarOpen: false,
  setScrollTop: (scrollTop) => set({ scrollTop }),
  setMobileSidebarOpen: (mobileSidebarOpen) => set({ mobileSidebarOpen }),
}));
